/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ateliere_Connect_Caption_Name_DefaultInputs */

const en_ateliere_connect_caption_name_default = /** @type {(inputs: Ateliere_Connect_Caption_Name_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`caption`)
};

const fr_ateliere_connect_caption_name_default = /** @type {(inputs: Ateliere_Connect_Caption_Name_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sous-titres`)
};

const de_ateliere_connect_caption_name_default = /** @type {(inputs: Ateliere_Connect_Caption_Name_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertitel`)
};

const it_ateliere_connect_caption_name_default = /** @type {(inputs: Ateliere_Connect_Caption_Name_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`didascalia`)
};

const ru_ateliere_connect_caption_name_default = /** @type {(inputs: Ateliere_Connect_Caption_Name_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`подпись`)
};

const es_ateliere_connect_caption_name_default = /** @type {(inputs: Ateliere_Connect_Caption_Name_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`subtítulo`)
};

const zh_cn2_ateliere_connect_caption_name_default = /** @type {(inputs: Ateliere_Connect_Caption_Name_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标题`)
};

const ja_ateliere_connect_caption_name_default = /** @type {(inputs: Ateliere_Connect_Caption_Name_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャプション`)
};

const hi_ateliere_connect_caption_name_default = /** @type {(inputs: Ateliere_Connect_Caption_Name_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैप्शन`)
};

const pt_pt2_ateliere_connect_caption_name_default = /** @type {(inputs: Ateliere_Connect_Caption_Name_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rubrica`)
};

/**
* | output |
* | --- |
* | "caption" |
*
* @param {Ateliere_Connect_Caption_Name_DefaultInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_caption_name_default = /** @type {((inputs?: Ateliere_Connect_Caption_Name_DefaultInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Caption_Name_DefaultInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ateliere_connect_caption_name_default(inputs)
	if (locale === "de") return de_ateliere_connect_caption_name_default(inputs)
	if (locale === "it") return it_ateliere_connect_caption_name_default(inputs)
	if (locale === "ru") return ru_ateliere_connect_caption_name_default(inputs)
	if (locale === "es") return es_ateliere_connect_caption_name_default(inputs)
	if (locale === "zh-CN") return zh_cn2_ateliere_connect_caption_name_default(inputs)
	if (locale === "ja") return ja_ateliere_connect_caption_name_default(inputs)
	if (locale === "hi") return hi_ateliere_connect_caption_name_default(inputs)
	if (locale === "pt-PT") return pt_pt2_ateliere_connect_caption_name_default(inputs)
	return en_ateliere_connect_caption_name_default(inputs)
});